<div [hidden]="isAdvancedSearch">
  <rav-basic-search [searchLabel]="searchLabel" (newBasicSearch)="onNewBasicSearch($event)"></rav-basic-search>
</div>

<div [hidden]="!isAdvancedSearch">
  <h6>Advanced Search</h6>
  <rav-advanced-search
    *ngFor="let n of advancedSearchesShown; let i = index"
    [dataType]="dataType"
    [advancedSearchIndex]="i"
    [plusButtonEnabled]="i === advancedSearchesShown.length - 1"
    (plusButtonClicked)="addAdvancedSearchOption()"
    (newAdvancedSearch)="onNewAdvancedSearch($event)"
    (searchRemoved)="removeAdvancedSearchOption($event)"
  ></rav-advanced-search>
</div>

<button mat-raised-button color="primary" class="margin-bottom-1" (click)="toggleAdvancedSearch()">
  {{ isAdvancedSearch ? 'Hide Advanced Search' : 'Show Advanced Search' }}
</button>
